import { IconExclamationCircle } from '@tabler/icons-react'

import { IconContainer } from '@/components/atoms/IconContainer'
import { Row } from '@/components/atoms/Row'
import { Typography } from '@/components/atoms/Typography'

type TProps = {
  text: string
}

export const ErrorMessage: React.FC<TProps> = ({ text }) =>
  text ? (
    <Row justify="center" align="center">
      <IconContainer mr={0.5}>
        <IconExclamationCircle color="error" />
      </IconContainer>
      <Typography c="error" pt="3px">
        {text}
      </Typography>
    </Row>
  ) : null
